import gql from 'graphql-tag';

export const NAME =
  'compositions_TechAdmin_Contacts_Form_deleteAfterHoursContactsMutation';

const query = gql`
  mutation ${NAME} (
    $contactIds: [ID!]!
  ) {
    deleteAfterHoursContacts(
      input: {
        ids: $contactIds
      }
    ) {
      deletedCount
    }
  }
`;

export default query;



// WEBPACK FOOTER //
// ./src/compositions/TechAdmin/DealerDetails/Contacts/withDeleteAfterHoursContact/deleteAfterHoursContactQuery.js